import { getStorage } from '@/helpers/Local'

export default {
    computed: {
        isDebugging: function () {
            return !!getStorage('debugging')
        },
    },
}
